import { createPinia } from "pinia";
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "nes.css/css/nes.min.css";

createApp(App).use(createPinia).use(router).mount('#app')
